<template>
  <div  id="cardwindow" class="card">

    <div class="card-header header-elements-inline bg-indigo-600" >
      <h5 v-if="voucher.code == 0" class="card-title">Stock Adjustment Creation</h5>
      <h5 v-if="voucher.code > 0" class="card-title"> Doc No: {{voucher.doc_no}}  Stock Adjustment Updation</h5>
      <div class="header-elements">
        <div class="list-icons">
          <a class="list-icons-item" data-action="reload" @click="loadData" ></a>
          <a class="list-icons-item" data-action="remove" @click="closeThis"></a>
        </div>
      </div>
    </div>

    <div class="card-body">

      <div class="row">

        <div class="col-md-3">

          <div class="form-group form-group-material">
            <label class="control-label text-semibold">Nozzle</label>
            <select class="form-control select" autofocus required v-if="voucher" v-model="voucher.nozzle.code" >
              <option v-for="ledger in nozzles" v-bind:value="ledger.code">
                {{ ledger.name }}
              </option>
            </select>
          </div>

        </div>
        <div class="col-md-7">

        </div>

        <div class="col-md-2">
          <div class="form-group form-group-material">
            <label class="control-label text-semibold">Date</label>
            <input id="txtDate" type="date" class="form-control" v-if="voucher" v-model="voucher.doc_date">
          </div>
        </div>
      </div>


      <div class="row">
        <!--  Detail Table -->
        <div class="table-responsive">
          <table id="mytable" class="table table-no-bordered">
            <thead style="background-color: lightgrey">
            <tr>
              <th style="width:50px;">S.No</th>
              <th >Particulars</th>
              <th >Description</th>
              <th style="width:150px; text-align: right;">Add</th>
              <th style="width:150px; text-align: right;">Less</th>
              <th style="width: 30px;">Action</th>
            </tr>

            </thead>
            <tbody >
            <tr v-model="voucher" v-for="(detail,index) in voucher.list" >
              <td style="text-align: center;padding: 0px;"> {{index + 1}} </td>
              <td style="padding: 0px;">
                <select class="form-control" v-if="detail" v-model="detail.item.code" >
                  <option v-for="ledger in items" v-bind:value="ledger.code">
                    {{ ledger.name }}
                  </option>
                </select>
              </td>
              <td style="padding: 0px;">
                <input type="text" class="form-control" placeholder="Description" maxlength="100"  v-if="detail" v-model="detail.desc" />
              </td>
              <td style="padding: 0px;">
                <input type="number" class="form-control text-right" min="0"  step="any" placeholder="0.00" v-if="detail" v-model="detail.credit" @change="sumRowAmountTotal" />
              </td>
              <td style="padding: 0px;">
                <input type="number" class="form-control text-right" min="0"  step="any" placeholder="0.00" v-if="detail" v-model="detail.debit" @change="sumRowAmountTotal" />
              </td>
              <td style="padding: 0px;text-align: right">
                <button name="btnRemoveRow"   type="button" class="btn border-warning text-warning-600 btn-flat btn-icon btn-rounded legitRipple btnRemoveRow" @click="removeRow(index)" tabindex="-1" ><i class="icon-eraser"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <td style="padding: 0px;">
                <button id="btnAddRow" type="button" class="btn border-success text-success-800 btn-flat btn-icon btn-rounded legitRipple" @click="addRow">
                  <i class="icon-plus3"></i>
                </button>
              </td>
              <td></td>
              <td></td>

              <td class="text-right" ><span style="padding-right: 15px;">{{ indianFormat(creditTotal) }}</span></td>
              <td class="text-right" ><span style="padding-right: 15px;">{{ indianFormat(debitTotal) }}</span></td>

            </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <!-- / Detail Table -->

      <div class="row">
        <div class="col-md-3">
          <div class="form-group form-group-material">
            <label class="control-label text-semibold">Narration</label>
            <textarea id="txtremarks" class="form-control" placeholder="Narration"  v-if="voucher" v-model="voucher.remarks" > </textarea>
          </div>
        </div>

        <div class="col-md-6">
        </div>

        <div class="col-md-3 text-right">
          <button id="btnSave" type="button" class="btn bg-green-800 btn-raised active" @click="saveVoucher">Save</button>
          <button type="button" id="btnclose" class="btn btn-default" data-dismiss="" @click="clear" >Clear</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import   moment from 'moment-timezone'
  import { userService } from '@/store/auth-header.js'
  import { store } from '@/store/store.js'

  export default {
    name: 'StockAdjustEntryForm',
    store,
    components: {
    },
    data () {
      return {
        readonly: false,
        nozzles:[],
        nozzles: [],
        items: [],
        creditTotal: 0.0,
        debitTotal: 0.0,
        voucher: JSON.parse('{"_id":"","code":0,"status":0,"locked":false,"type":0,"ibr":0,"finyear":0,"doc_date":"0001-01-01","doc_no":"","nozzle":{"_id":"","code":0,"name":""},"remarks":"","maker":"","list":[]}')
      }
    },
    props: {
      myvoucher: {
        type: Object,
        default: () => JSON.parse('{"_id":"","code":0,"status":0,"locked":false,"type":0,"ibr":0,"finyear":0,"doc_date":"0001-01-01","doc_no":"","nozzle":{"_id":"","code":0,"name":""},"remarks":"","maker":"","list":[]}')
      }
    },
    beforeMount () {
      this.voucher = this.myvoucher;
      this.sumRowAmountTotal();
    },
    created () {
      this.$data.voucher.doc_date = moment().format('YYYY-MM-DD');
    },
    mounted () {
      const self = this;
      self.loadData();
      self.loadItems();

      if (self.$data.voucher.doc_date == '0001-01-01') {
        self.$data.voucher.doc_date = moment().format('YYYY-MM-DD');
      }


    },
    methods: {
      indianFormat (val) {
        return parseFloat(val).toFixed(2);
      },
      closeThis () {

        if (this.$data.voucher.code > 1) {

          this.$emit('stockadjust_window_closed');

          this.$modal.hide('voucher-window');
          this.voucher = JSON.parse('{"_id":"","code":0,"status":0,"locked":false,"type":0,"ibr":0,"finyear":0,"doc_date":"0001-01-01","doc_no":"","nozzle":{"_id":"","code":0,"name":""},"remarks":"","maker":"","list":[]}')
        } else {
          this.$router.push('/');
        }
      },
      addRow () {
        const self = this;
        self.$data.voucher.list.push(JSON.parse('{"item":{"_id":"","code":0,"name":"","salerate":0,"group":{"_id":"","code":0,"name":"","pname":"","hsn":"","taxrate":0,"nature":1,"itc":0},"min_qty":0,"max_qty":0,"unit":1},"desc":"","unit":4,"credit":0,"debit":0}'));
      },
      sumRowAmountTotal () {
        const self = this;

        self.$data.creditTotal = 0.0;
        self.$data.debitTotal = 0.0;

        self.$data.voucher.list.forEach(function (detail) {
          self.$data.creditTotal += parseFloat(detail.credit);
          self.$data.debitTotal += parseFloat(detail.debit);
        });

      },
      clear () {
        const self = this;
        self.$data.voucher = JSON.parse('{"_id":"","code":0,"status":0,"locked":false,"type":0,"ibr":0,"finyear":0,"doc_date":"0001-01-01","doc_no":"","nozzle":{"_id":"","code":0,"name":""},"remarks":"","maker":"","list":[]}');

        self.$data.voucher.list = [];
        self.$data.creditTotal = 0.0;
        self.$data.voucher.doc_date = moment().format('YYYY-MM-DD');
      },
      loadData () {
        const self = this;

        const requestOptions = {
          mode: 'cors',
          headers: userService.authHeader()
        }

        // fetch the nozzles
        self.$data.nozzles = [];

        fetch(`${process.env.VUE_APP_ROOT_API}api/v1/xbunk/nozzle/`, requestOptions).then(userService.handleResponse).then(function (resp) {
          if (resp.accepted) {
            if(_.isArray(resp.data)){
              self.$data.nozzles = resp.data;
            }
          } else {
            swal({ title: 'Oops', text: resp.msg, type: 'error' })
          }
        }).catch(function (err) {
          swal({ title: 'Oops', text: err.toString(), type: 'error' })
        });

      },
      loadItems() {
        const self = this;

        const requestOptions = {
          mode: 'cors',
          headers: userService.authHeader()
        }

        // Fetch Detail Ledgers
        self.$data.items = [{"_id":"5d7df0ebab18195d46ca5c7b","key":"PETROL","code":101,"name":"Petrol","hsn":"","gstrate":0,"salerate":77.9,"porder":-4,"group_cd":1,"group":{"_id":"5dcf689ceffc814aaec8323a","key":"","code":1,"name":"","pname":"","hsn":"","taxrate":0,"nature":1,"itc":100}},{"_id":"5d7e2a24ab18195d46ca5c7d","key":"DIESEL","code":102,"name":"Diesel","hsn":"","gstrate":0,"salerate":71.11,"porder":-2,"group_cd":1,"group":{"_id":"5dcf689ceffc814aaec8323a","key":"","code":1,"name":"","pname":"","hsn":"","taxrate":0,"nature":1,"itc":100}},{"_id":"5d7e2acaab18195d46ca5c7f","key":"SPEED","code":103,"name":"Speed","hsn":"","gstrate":0,"salerate":80.83,"porder":-1,"group_cd":1,"group":{"_id":"5dcf689ceffc814aaec8323a","key":"","code":1,"name":"","pname":"","hsn":"","taxrate":0,"nature":1,"itc":100}}];


      },
      removeRow (index) {
        if (index > -1) {
          this.$data.voucher.list.splice(index, 1);
          this.sumRowAmountTotal();
        }
      },
      saveVoucher () {
        const self = this;

        let myvoucher = JSON.parse(JSON.stringify(self.$data.voucher));
        myvoucher.finyear = store.state.user.finyear;
        myvoucher.ibr = parseInt(localStorage.getItem('branch_code'));
        myvoucher.nozzle.code = parseInt(myvoucher.nozzle.code);
        myvoucher.doc_date = moment(myvoucher.doc_date).format('YYYY-MM-DD');// + 'T00:00:00Z'


        myvoucher.list.forEach(function (detail) {
          detail.qty = parseFloat(detail.qty);
        });


        const requestOptions = {
          method: ((myvoucher.code == 0) ? 'POST' : 'PUT'),
          mode: 'cors',
          headers: userService.authHeader(),
          body: JSON.stringify(myvoucher)
        }

        $('#cardwindow').block({
          message: '<i class="icon-spinner2 spinner"></i>',
          overlayCSS: {
            backgroundColor: '#fff',
            opacity: 0.8,
            cursor: 'wait',
            'box-shadow': '0 0 0 1px #ddd'
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: 'none'
          }
        });

        fetch(`${process.env.VUE_APP_ROOT_API}api/v1/stock/stockadjust/`, requestOptions).then(userService.handleResponse).then(function (resp) {
          if (resp.accepted) {
            swal({title: 'Success', type: 'success', text: resp.msg });
            self.clear();
            self.$emit('stockadjust_saved');

          } else {
            swal({ title: 'Oops', text: resp.msg, type: 'error' });
          }
        }).catch(function (err) {
          swal({ title: 'Oops', text: err.toString(), type: 'error' });
        }).finally(function () {
          $('#cardwindow').unblock();
        });
      },

    }
  }
</script>

<style scoped>

</style>
